import { render } from "./quiz-chat.vue?vue&type=template&id=754d2a14&ts=true"
import script from "./quiz-chat.vue?vue&type=script&lang=ts"
export * from "./quiz-chat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__